import { Badge } from '@cfa/react-components';
import React from 'react';
import styled from 'styled-components';

interface Props {
  modifiers: ModifierView[];
}

const ModifierList: React.FC<Props> = ({ modifiers }) => {
  return (
    <StyledModifierList>
      <div className="scroll-container">
        {modifiers.map(({ tag, imgUrl, name, quantity }, index) => (
          <Badge
            color="secondary"
            content={quantity > 1 ? `${quantity}` : undefined}
            hide={!quantity || quantity === 1}
            key={`${tag}-${index}`}
            overlap="circular"
          >
            <div className="circle-box">
              <div className="circle">
                <div className="image-wrapper">
                  <img alt={name} className="image" src={imgUrl} />
                </div>
              </div>
              <div className="modifier-name">{name}</div>
            </div>
          </Badge>
        ))}
      </div>
    </StyledModifierList>
  );
};

const StyledModifierList = styled.div`
  width: auto;
  margin: 0 -20px; /* Adjusted to match the padding of the scroll container */

  & .scroll-container {
    display: flex;
    overflow-x: auto;
    gap: 2px;
    padding-left: 40px;
  }

  & .circle-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    min-width: 86px;
    min-height: 102px;
  }

  & .circle {
    width: 54px;
    height: 54px;
    background-color: #ecedee;
    border-radius: 50px;
    flex-shrink: 0; /* Prevents circles from shrinking */
    margin-bottom: 8px; /* Add space between circle and text */
  }

  & .modifier-name {
    font: ${(props) => props.theme.smallTextFont};
    text-align: center;
    width: 86px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: ${(props) => props.theme.lineHeights.copy};
    word-wrap: break-word;
    hyphens: auto;
    flex: 1; /* Takes remaining space */
  }

  & .image {
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
  }

  & .cfa-badge {
    height: 22px;
    width: 22px;
    border-radius: 50%;
  }
`;

export default ModifierList;
